import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { getReportType } from "../../redux/action";
import {
  PATINET_DOC_UPLOAD,
  SUBMIT_RELATIVE_INTAKE_FROM,
  UPLOAD_CLICNICAL_INTAKE_DOC,
  UPLOAD_CLICNICAL_INTAKE_FILE,
  UPLOAD_CLICNICAL_INTAKE_SUBMIT,
  VERIFY_RELATIVE_INTAKE_FROM,
  VERIFY_RELATIVES_SUBMIT_API_URL,
} from "../../action/apiPath";
import { CallWithAuth, CallWithOutAuth } from "../../action/apiActions";
import mic from "../../assets/img/mic.png";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { showToast, ToastContainer } from "../../util/toastHelper";
import { errorMessageCreate, fileName } from "../../util/custom";
import DigitalSignature from "../../components/digitalSignature";
import { base64ToFile } from "../../util/base64ToFile";
import ReactSignatureCanvas from "react-signature-canvas";
import "./signature.css"; // Import the CSS file for styling
import pdfMake from "pdfmake/build/pdfmake";
import logo from "../../assets/img/logo.svg";

import pdfFonts from "pdfmake/build/vfs_fonts";
import { PatientFooter } from "../../components/patient/PatientFooter";
import PatientHeader from "../../components/patient/PatientHeader";

// Dynamically load fonts
pdfMake.vfs = {
  ...pdfMake.vfs,
  "Roboto-Regular.ttf": require("./Roboto-Regular.ttf").default,
  "Roboto-Medium.ttf": require("./Roboto-Medium.ttf").default,
  "Roboto-Italic.ttf": require("./Roboto-Italic.ttf").default,
  "Roboto-MediumItalic.ttf": require("./Roboto-MediumItalic.ttf").default,
};

// Define custom fonts
pdfMake.fonts = {
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

export default function RelaTiveIntakeSubmitFormDetail() {
  const navigate = useNavigate();
  const [activeField, setActiveField] = useState(null);

  const location = useLocation();
  const [successfullSubmission, setSuccessfullSubmission] = useState(false);

  // for modal
  const [isVerified, setIsVerified] = useState(false);
  const [getotp, setOtp] = useState(null);

  const [isVerifiedOtp, setIsVerifiedOtp] = useState(false);

  const [mailToken, setMailToken] = useState("");
  const [patientName, setPatientName] = useState("");
  const [patientConsent, setPatientConsent] = useState(false);
  const pageWidth = 595.28; // A4 width in points
  const pageHeight = 841.89; // A4 height in points
  const margin = 40;

  useEffect(() => {
    // Use URLSearchParams to get the token from the URL
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get("token");
    const docsIdsParam = params.get("docs");

    // console.log("tokenParam", tokenParam);
    // let hasVerified = localStorage.getItem("isVerified");
    // let storageToken = localStorage.getItem("tokenParam");
    // // console.log("hasVerified=====>", hasVerified);
    // if (
    //   (hasVerified == "true" || hasVerified == true) &&
    //   hasVerified != null &&
    //   hasVerified != undefined &&
    //   hasVerified != "undefined" &&
    //   storageToken == tokenParam
    // ) {
    //   // console.log("hasVerified=====>143", hasVerified);
    //   setIsVerified(true);
    // } else {
    //   setIsVerified(false);
    //   localStorage.setItem("isVerified", false);
    //   localStorage.setItem("isFromSubmit", false);
    // }
    setIsVerified(false);
    setMailToken(tokenParam);

    // setIsVerified(false);

    // if (tokenParam != undefined && tokenParam != null && tokenParam != "") {
    //   // console.log("tokenParam", tokenParam);
    //   setMailToken(tokenParam);
    // } else {
    //   navigate("/");
    // }
  }, [location]);

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));
  };

  const convertImageToBase64 = (imagePath, callback) => {
    const reader = new FileReader();
    const img = new Image();

    img.src = imagePath;
    img.crossOrigin = "Anonymous"; // Avoid CORS issues for external images

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(img, 0, 0);
      const base64String = canvas.toDataURL("image/png"); // Convert to Base64
      callback(base64String);
    };
  };

  const handleOtp = async () => {
    let isValid = true;
    if (!getotp || getotp == "" || getotp.trim() == "") {
      isValid = false;
    }

    // return ;
    if (isValid) {
      setIsVerifiedOtp(true);
      try {
        const response = await CallWithOutAuth(
          "POST",
          `${VERIFY_RELATIVES_SUBMIT_API_URL}`,
          {
            otp: getotp,
            token: mailToken,
          }
        );
        if (response?.res?.data?.statusCode === 200) {
          // console.log(response?.res?.data?.data?.patinet);

          // localStorage.setItem("isVerified", true);
          // localStorage.setItem("tokenParam", mailToken);

          // setIsVerified(true);

          // setPatientConsent(true);
          let data = response?.res?.data?.data;
          // console.log('data======>',data);

          let files = [];
          files = data?.files?.map((item, key) => {
            return encodeURI(item.file); // Assuming `item.id` is the property you want to extract
          });
          console.log(files);
          convertImageToBase64(logo, (base64) => {
            const docDefinition = {
              pageSize: { width: 595.28, height: 841.89 }, // A4 size in points
              pageMargins: [40, 60, 40, 60],
              content: [
                {
                  image: base64, // Insert the Base64 image
                  width: 100,
                  // alignment: "center",
                  margin: [0, 0, 0, 20],
                },
                {
                  text: "PsychScribe: Clinical Intake Form",
                  style: "header",
                  margin: [0, 0, 0, 10],
                },
                {
                  text: `${data?.patient?.full_name} has provided their written consent to obtain information from yourself to assist with their upcoming diagnostic assessment and report being completed by ${data?.name}. Information is protected under the 1988 Privacy Act and is securely secured on our HIPPA and APP compliant platform PsychScribe. You are not obliged to share information, however if your decision is to not share information, although not mandated, we advise in the interest of good clinical practice, that you should communicate your reasoning with ${data?.patient?.full_name}.`,
                  // style: "header",
                },
                {
                  text: "Important Note:",
                  style: "header",
                  margin: [0, 10, 0, 10],
                },
                `When sharing information, please be aware that it will be viewed by in the final report. Please ensure the information is objective and accurate, free of bias and is shared strictly for the purpose of a diagnostic assessment and report. The information shared will undergo editing by our Artificial Intelligence (AI) algorithms prior to being transferred into ${data?.patient?.full_name} report to assist with formatting for ${data?.name}, however the original text information and a summary of supplied documents will be provided to both you and ${data?.name} once you have finalised submission.`,

                {
                  text: `Please also note PsychScribe Pty LTD is not legally responsible for any inaccuracies between the original text and the AI edited text in the report and it is ${data?.name} responsibility to cross-reference the material, ensuring they review any clinically inaccurate information prior to final submission of the report.`,
                  margin: [0, 10, 0, 10],
                },
                // {
                //   text: `Please provide any relevant information below that may assist with the diagnostic assessment and report  ${data?.patient?.full_name} below:${data?.patient_relevant_extra_info}.`,
                // },
                {
                  // text: [
                  //   `Relevant information below that may assist with the diagnostic assessment and report ${data?.patient?.full_name} below:`,
                  //   // { text: data?.patient?.full_name}, // Bold patient name
                  //   // ` below: ${data?.patient_relevant_extra_info}.`,
                  //   {text: data?.patient_relevant_extra_info ,bold:true},

                  // ],
                  text: [
                    {
                      text: `Relevant information below that may assist with the diagnostic assessment and report ${data?.patient?.full_name} below:`,
                      margin: [0, 0, 10, 10], // Adds space below this text
                    },
                    {
                      text: data?.patient_relevant_extra_info,
                      bold: true,
                      margin: [0, 10, 0, 10], // Adds spacing above and below the bold text
                    },
                  ],
                },
                {
                  text: `Relevant documents below that might also assist with the diagnostic assessment and report for ${data?.patient?.full_name}.`,
                  margin: [0, 10, 0, 10],
                },
                // {
                //   ul: ["item 1", "item 2", "item 3"],
                // },
                ...(data?.files?.length > 0
                  ? [
                      {
                        // ul: [files], // Adjust `file` property as needed
                        ul: files.map((file) => {
                          // const encodedUrl = encodeURI(`${file}`);
                          const encodedUrl = `${file}`;

                          return {
                            text: `[${encodedUrl}]`,
                            link: encodedUrl,
                            color: "blue",
                            decoration: "underline",
                            target: "_blank", // Open link in a new tab
                          };
                        }),
                      },
                    ]
                  : []),
                // "Digital signature",
                // {
                //   text: "Digital Signature",
                //   ...(data?.signature && data?.signature !== ""
                //     ? {
                //         style: "header",
                //         link: encodeURI(data?.signature), // Make it a clickable link
                //         color: "blue", // Optional: blue color for link
                //         decoration: "underline", // Optional: underline for clarity
                //       }
                //     : {}),
                // },
              ],
              styles: {
                header: {
                  fontSize: 18,
                  bold: true,
                },
                subheader: {
                  fontSize: 15,
                  bold: true,
                },
                quote: {
                  italics: true,
                },
                small: {
                  fontSize: 8,
                },
              },
            };

            pdfMake
              .createPdf(docDefinition)
              .download("PsychScribe_Clinical_Intake_Form.pdf");
          });
        } else {
          let message = errorMessageCreate(response?.res?.data?.message);
          showToast("error", message);
        }
      } catch (err) {
        console.log(err);
      }
      setIsVerifiedOtp(false);
    } else {
      showToast("error", "OTP fields is required.");
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <PatientHeader />
      <div className="container">
        <section className="clinical-intake-form">
          {successfullSubmission ? (
            <h1>
              Thank you for sharing information in the best interest of{" "}
              {patientName} care. You should receive a copy of the original text
              (pdf format) of your submission via a secure email link shortly.
              This pdf is a medical record and should be stored compliantly with
              the relevant health legislation which governs your professional
              role.{" "}
            </h1>
          ) : (
            <>
              <div className="container">
                {isVerified ? (
                  <>
                    <h3>Thank you</h3>
                  </>
                ) : (
                  <>
                    <Modal show={!isVerified}>
                      <Modal.Header>
                        <Modal.Title>Verify OTP</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Hi {`user`} ,<h5>Not Authorized to access this page</h5>
                        <p>
                          Please verify the one-time OTP you received in your
                          email to view the details.
                        </p>
                        <div className="row">
                          <div class="field_block col-md-12">
                            <label for="">
                              OTP <sup className="text-danger">*</sup>
                            </label>
                            <input
                              type="text"
                              name="otp"
                              className="text_field form-control"
                              placeholder="Enter OTP"
                              onChange={(e) => setOtp(e.target.value)}
                              // value={patientDetail.full_name}
                              // onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="primary"
                          onClick={handleOtp}
                          type="button"
                        >
                          Verify OTP {" "}
                          {isVerifiedOtp && (
                            <>
                              {""}
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            </>
                          )}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                )}
              </div>
            </>
          )}
        </section>
      </div>
      <ToastContainer />
      <PatientFooter is_relative={true} />
    </>
  );
}
